import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Card, CardContent } from "@/components/ui/card";
import { Control } from "react-hook-form";
import { UserRole } from "@/pages/auth/types";
import { EmployeeFormValues } from "../schemas/employeeFormSchema";

interface RoleSelectionFormProps {
  control: Control<EmployeeFormValues>;
}

export const RoleSelectionForm = ({ control }: RoleSelectionFormProps) => {
  return (
    <CardContent className="space-y-4 pt-6">
      <h3 className="text-lg font-semibold">User Role</h3>
      <FormField
        control={control}
        name="role"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Select Role</FormLabel>
            <Select onValueChange={field.onChange} value={field.value}>
              <FormControl>
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select a role" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="ROLE_USER">User</SelectItem>
                <SelectItem value="ROLE_ADMIN">Admin</SelectItem>
              </SelectContent>
            </Select>
          </FormItem>
        )}
      />
    </CardContent>
  );
};
